import { cn } from "@omni/utils/styles";

import { useProductPageContext } from "../../context/productPage.context";

type PromoBannerProps = {
    className?: string;
};

export const PromoBanner = ({ className }: PromoBannerProps) => {
    const { promoBannerHTML } = useProductPageContext();

    if (!promoBannerHTML) return null;

    const html = new TextDecoder("utf-8").decode(
        Uint8Array.from(atob(promoBannerHTML), (c) => c.charCodeAt(0))
    );

    return (
        <div
            className={cn("tw:mb-6", className)}
            dangerouslySetInnerHTML={{
                __html: html
            }}
        />
    );
};
